/**
 * IntroTour.js - Premium Interactive Tour for GeoPST
 * Re-designed for high engagement and professional look
 */

function startGeoPSTTour() {
    const intro = introJs();
    const isMobile = window.innerWidth <= 768;

    // Mobile-optimized steps (skip sidebar elements that are hidden)
    const mobileSteps = [
        {
            title: 'مرحباً بك في GeoPST 👋',
            intro: `
                <div style="text-align: center;">
                    <img src="assets/Logo/Logo.png" style="width: 60px; margin: 0 auto 12px auto;">
                    <p style="font-weight: 600; font-size: 0.95rem; color: var(--primary);">بوابتك الذكية للخرائط الجغرافية</p>
                    <p style="margin-top: 8px; font-size: 0.85rem;">سنقوم بجولة سريعة لتعريفك بأدوات المنصة.</p>
                </div>
            `
        },
        {
            element: '#identifyToggleBtn',
            title: 'ℹ️ أداة الاستعلام',
            intro: 'اضغط هنا ثم انقر على أي قطعة أرض لعرض تفاصيلها.',
            position: 'bottom'
        },
        {
            element: '#basemap-switcher',
            title: '🗺️ خرائط الأساس',
            intro: 'اختر المظهر المناسب: خرائط شوارع أو صور جوية.',
            position: 'top'
        },
        {
            element: '#mainMenuBtn',
            title: '☰ القائمة الرئيسية',
            intro: 'افتح القائمة الجانبية للوصول لجميع الأدوات: البحث، الطبقات، القياس، والمزيد.',
            position: 'bottom'
        },
        {
            title: 'ابدأ رحلتك الآن! 🚀',
            intro: `
                <div style="text-align: center;">
                    <i class="fas fa-check-circle" style="font-size: 2.5rem; color: var(--success); margin-bottom: 12px;"></i>
                    <p style="font-weight: 700;">أنت الآن مستعد لاستكشاف فلسطين!</p>
                    <p style="font-size: 0.8rem; margin-top: 8px; color: var(--text-muted);">افتح القائمة الجانبية لاكتشاف المزيد.</p>
                </div>
            `
        }
    ];

    // Desktop steps (full tour)
    const desktopSteps = [
        {
            title: 'مرحباً بك في GeoPST 👋',
            intro: `
                <div style="text-align: center;">
                    <img src="assets/Logo/Logo.png" style="width: 80px; margin: 0 auto 15px auto;">
                    <p style="font-weight: 600; font-size: 1rem; color: var(--primary);">بوابتك الذكية للخرائط الجغرافية</p>
                    <p style="margin-top: 10px; font-size: 0.9rem;">سنقوم بجولة سريعة لتعريفك بأدوات المنصة المتقدمة وكيفية استغلالها بأفضل صورة.</p>
                </div>
            `
        },
        {
            element: '#topSearchForm',
            title: '🚀 البحث السريع',
            intro: 'هل تبحث عن منطقة بسرعة؟ استخدم هذا الشريط للبحث عن المدن والقرى في فلسطين والوصول إليها فوراً.',
            position: 'bottom'
        },
        {
            element: '#govInput',
            title: '🔍 البحث العقاري التفصيلي',
            intro: 'هنا يمكنك البحث بدقة متناهية عن <strong>المحافظة</strong>، <strong>التجمع</strong>، <strong>رقم الحوض</strong>، وحتى <strong>رقم قطعة الأرض</strong>.',
            position: 'right'
        },
        {
            element: '#layers',
            title: '🗂️ الطبقات الجغرافية',
            intro: 'تحكم في ما يظهر على الخريطة. يمكنك تفعيل طبقة <strong>الأراضي</strong>، <strong>المباني</strong>، أو حتى <strong>تصنيف أوسلو</strong> والمحميات الطبيعية.',
            position: 'right'
        },
        {
            element: '#measure',
            title: '📏 أدوات القياس',
            intro: 'قس المسافات بين النقاط أو المساحات المعقدة (بالمتر المربع والدونم) بدقة احترافية وسهولة تامة.',
            position: 'right'
        },
        {
            element: '#draw',
            title: '🎨 الرسم والتدوين',
            intro: 'أضف لمستك الخاصة. يمكنك رسم أشكال توضيحية، إضافة نصوص، أو تحديد مواقع معينة وحفظها.',
            position: 'right'
        },
        {
            element: '#gpsTool',
            title: '📍 الذهاب للإحداثيات',
            intro: 'هل تملك إحداثيات (X, Y)؟ أدخلها هنا وسينقلك النظام مباشرة إلى الموقع المطلوب على خريطة فلسطين.',
            position: 'right'
        },
        {
            element: '#btnOpenRouting',
            title: '🛣️ الملاحة والمسارات',
            intro: 'أداة ذكية لحساب المسار بين عدة نقاط، معرفة الوقت المقدر والمسافة، والاستعداد للانطلاق.',
            position: 'right'
        },
        {
            element: '#dropArea',
            title: '📁 استيراد ملفاتك',
            intro: 'هل لديك ملف <strong>KML</strong> أو <strong>Excel</strong> أو <strong>Shapefile</strong>؟ اسحبه هنا وسيتم عرضه فوراً فوق الخريطة.',
            position: 'right'
        },
        {
            element: '#identifyToggleBtn',
            title: 'ℹ️ أداة الاستعلام',
            intro: 'فعّل هذه الأداة ثم اضغط على أي قطعة أرض لعرض تفاصيلها وبياناتها العقارية، أو استخراج <strong>تقرير PDF/JPG</strong> عنها.',
            position: 'left'
        },
        {
            element: '#basemap-switcher',
            title: '🗺️ خرائط الأساس',
            intro: 'اختر المظهر المناسب لخريطتك: خرائط شوارع، صور جوية حديثة 2023، أو مقارنة تاريخية مع صور عام 1970.',
            position: 'left'
        },
        {
            element: '#themeToggle',
            title: '🌓 الوضع الليلي والنهاري',
            intro: 'لا تنسَ اختيار الوضع الذي يريح عينيك. GeoPST تدعم الوضع الداكن الأنيق والوضع الفاتح المشرق.',
            position: 'bottom'
        },
        {
            title: 'ابدأ رحلتك الآن! 🚀',
            intro: `
                <div style="text-align: center;">
                    <i class="fas fa-check-circle" style="font-size: 3rem; color: var(--success); margin-bottom: 15px;"></i>
                    <p style="font-weight: 700;">أنت الآن مستعد لاستكشاف فلسطين جغرافياً!</p>
                    <p style="font-size: 0.85rem; margin-top: 10px; color: var(--text-muted);">يمكنك دائماً إعادة هذه الجولة من القائمة الجانبية بالأسفل.</p>
                </div>
            `
        }
    ];

    // Configuration
    intro.setOptions({
        nextLabel: 'التالي <i class="fas fa-chevron-left"></i>',
        prevLabel: '<i class="fas fa-chevron-right"></i> السابق',
        skipLabel: '<i class="fas fa-times"></i>',
        doneLabel: '<i class="fas fa-check"></i> فهمت!',
        hidePrev: true,
        showStepNumbers: false,
        showBullets: true,
        showProgress: true,
        exitOnOverlayClick: false,
        disableInteraction: false,
        scrollToElement: !isMobile, // Disable scroll on mobile
        scrollPadding: isMobile ? 0 : 50,
        positionPrecedence: isMobile ? ["bottom", "top"] : ["bottom", "top", "right", "left"],
        tooltipClass: isMobile ? 'introjs-mobile' : '',
        steps: isMobile ? mobileSteps : desktopSteps
    });

    // Handle interactions logic (only for desktop)
    if (!isMobile) {
        intro.onbeforechange(function (targetElement) {
            // Automatically open sidebar if element is inside it
            if (targetElement && (targetElement.closest('#sidebar') || targetElement.id === 'govInput')) {
                if (!$('#sidebar').hasClass('open')) {
                    $('#sidebar').addClass('open');
                    $('#map').css('right', '300px');
                }
            }
        });
    }

    intro.oncomplete(function () {
        localStorage.setItem('geopst_tour_completed', 'true');
        confettiEffect();
    });

    intro.start();
}

/**
 * Visual effect to celebrate completion
 */
function confettiEffect() {
    // Check if we have a simple CSS way or just log
    console.log("%c 🎉 Tour Completed!", "color: #c41e3a; font-size: 20px; font-weight: bold;");
}

// Global exposure
window.startGeoPSTTour = startGeoPSTTour;

$(document).ready(() => {
    // Bind the start button
    const tourBtn = document.getElementById('startTour');
    if (tourBtn) {
        tourBtn.onclick = (e) => {
            e.preventDefault();
            startGeoPSTTour();
        };
    }
});
